module.exports = __webpack_public_path__ + "img/clothing195.10200e29.jpg";